import { useCallback } from 'react';
import { useUpdateFilters } from '@/hooks/useUpdateFilters';

export const useMetricKeyFilter = () => {
  const { updateFilters } = useUpdateFilters('main');

  const setMetricKey = useCallback((metric: string) => updateFilters({ metric }), [updateFilters]);

  return { setMetricKey };
};
